import { PRIVACY_CORE_EVENT_NAMESPACE, INLINE_COOKIE_EVENT_NAMESPACE } from "../constants";

/**
 * @name createCustomEvent
 * @description A wrapper for creating custom events
 * @param {string} eventName - Event name string to create a CustomEvent with
 * @param {CustomEventOptions} customEventOptions - Options for creating
 * @returns {CustomEvent} A new CustomEvent @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEventhttps://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */
export function createCustomEvent(eventName, customEventOptions) {
  // NOTE - CustomEvent not supported in IE
  return new CustomEvent(eventName, customEventOptions);
}

/**
 * @name dispatchCustomEvent
 * @description A wrapper for dispatching custom events for now
 * @param {CustomEvent} customEvent - A native CustomEvent @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEventhttps://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */
export function dispatchCustomEvent(customEvent) {
  window.dispatchEvent(customEvent);
}

/**
 * @name dispatchEvent
 * @description A wrapper for dispatching custom events for now
 * @param {string} eventName - Event name string to create a CustomEvent with
 * @param {CustomEventOptions} customEventOptions - Options for creating
 */
export function dispatchEvent(eventName, customEventOptions) {
  dispatchCustomEvent(createCustomEvent(eventName, customEventOptions));
}
/**
 * @name getPrivacyCoreEventName
 * @description Returns a custom event names based on passed name and uniques event prefix
 * @param {PrivacyCoreCustomEventName} name - Name of the custom event
 * @param {string} [uniqueEventsPrefix] - A unique extra prefix for custom events
 * @returns {string}
 */
export const getPrivacyCoreEventName = (name, uniqueEventsPrefix = '') => `${PRIVACY_CORE_EVENT_NAMESPACE}${uniqueEventsPrefix}${name}`;
/**
 * @name getPrivacyCoreEventName
 * @description Returns a custom event names based on passed name and uniques event prefix
 * @param {InlineCustomEventName} name - Name of the custom event
 * @param {string} [uniqueEventsPrefix] - A unique extra prefix for custom events
 * @returns {string}
 */
export const getInlineEventName = (name, uniqueEventsPrefix = '') => `${INLINE_COOKIE_EVENT_NAMESPACE}${uniqueEventsPrefix}${name}`;